import { createSelector } from "reselect"
import { initialState } from "./reducer"

const selectForgottenPasswordDomain = (state) =>
  state.get("ForgottenPassword", initialState)

export const makeSelectError = () =>
  createSelector(selectForgottenPasswordDomain, (recoveryState) =>
    recoveryState.get("error")
  )
export const makeSelectErrorMessage = () =>
  createSelector(selectForgottenPasswordDomain, (recoveryState) =>
    recoveryState.get("errorMessage")
  )
export const makeSelectSuccess = () =>
  createSelector(selectForgottenPasswordDomain, (recoveryState) =>
    recoveryState.get("success")
  )
export const makeSelectEmail = () =>
  createSelector(selectForgottenPasswordDomain, (recoveryState) =>
    recoveryState.get("email")
  )

export const makeSelectLoading = () =>
  createSelector(selectForgottenPasswordDomain, (recoveryState) =>
    recoveryState.get("isLoading")
  )

const makeSelectPasswordRecovery = () =>
  createSelector(selectForgottenPasswordDomain, (substate) => substate.toJS())

export default makeSelectPasswordRecovery
export { selectForgottenPasswordDomain }
